{
  "Customer support": {
    "value": "68%",
    "description": "of contact centers say agents spend 10% to 29% of their time on manual after-call work.",
    "source": "IDC for Talkdesk, 2025",
    "href": "https://www.silicon.co.uk/press-release/harnessing-technology-and-talent-study-reveals-the-critical-need-for-contact-centers-to-deploy-artificial-intelligence-and-automation-technologies-to-alleviate-customer-frustration-and-strain-on-agen"
  },
  "Customer success": {
    "value": "66%",
    "description": "of customer success managers still spend a big part of their day on repetitive admin processes.",
    "source": "Vitally, 2023 survey of 679 CSMs",
    "href": "https://www.vitally.io/post/which-parts-of-the-job-would-csms-automate"
  },
  "Engineering": {
    "value": "69%",
    "description": "of developers lose eight or more hours a week to inefficiencies.",
    "source": "Atlassian, State of Developer Experience 2024",
    "href": "https://www.atlassian.com/blog/developer/developer-experience-report-2024"
  },
  "IT and admin": {
    "value": "58%",
    "description": "of organizations say IT spends over five hours a week on repetitive business requests.",
    "source": "InformationWeek for TeamDynamix, 2023",
    "href": "https://www.teamdynamix.com/stop-the-insanity-put-more-time-back-in-your-day/"
  },
  "Founders and leadership": {
    "value": "36%",
    "description": "of a founder's working week goes to administrative tasks.",
    "source": "Censuswide for Time etc, 2023",
    "href": "https://timeetc.com/resources/how-to-achieve-more/the-big-price-of-small-tasks-how-entrepreneurs-may-be-unwittingly-keeping-their-businesses-small"
  },
  "Software": {
    "value": "50%",
    "description": "of developers lose 10 or more hours a week to organizational inefficiencies.",
    "source": "Atlassian, State of Developer Experience 2025",
    "href": "https://www.atlassian.com/blog/developer/developer-experience-report-2025"
  }
}
